import { render, staticRenderFns } from "./ScreenInstitucion.vue?vue&type=template&id=1191f51e"
import script from "./ScreenInstitucion.vue?vue&type=script&lang=js"
export * from "./ScreenInstitucion.vue?vue&type=script&lang=js"
import style0 from "./ScreenInstitucion.vue?vue&type=style&index=0&id=1191f51e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports